import React, { useRef, useEffect } from 'react';
import styled from '@emotion/styled';

function ScrollToTop() {
  const scrollToTopBtn = useRef(null);

  // const callback = entries => {
  //   // The callback will return an array of entries, even if you are only observing a single item
  //   entries.forEach(entry => {
  //     if (entry.isIntersecting) {
  //       // Show button
  //       scrollToTopBtn.current.classList.add('showBtn');
  //     } else {
  //       // Hide button
  //       scrollToTopBtn.current.classList.remove('showBtn');
  //     }
  //   });
  // };

  // useEffect(() => {
  //   if ('IntersectionObserver' in window && scrollToTopBtn.current) {
  //     const observer = new IntersectionObserver(callback, {
  //       threshold: 0.1,
  //       // root: document.body,
  //       // rootMargin: '-30% 0px 0px 0px',
  //     });
  //     if (scrollToTopBtn.current) {
  //       observer.observe(scrollToTopBtn.current);
  //     }
  //   }
  // }, [scrollToTopBtn]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };
  return (
    <ScrollButton
      ref={scrollToTopBtn}
      onClick={scrollToTop}
      className="md:block hidden z-10 fixed showBtn left-6 bottom-6 bg-black opacity-90 p-2 rounded-full"
    >
      <svg
        className="w-6 h-6"
        fill="none"
        stroke="white"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 15l7-7 7 7"
        />
      </svg>
    </ScrollButton>
  );
}

export default ScrollToTop;

const ScrollButton = styled.button`
  opacity: 0;
  transform: translateY(100px);
  transition: all 0.5s ease;
  outline: none;

  &.showBtn {
    opacity: 1;
    transform: translateY(0);
  }
`;
